import React from "react";
// import BlockUi from "react-block-ui";
import BlockUi from '@availity/block-ui';
import Loaders from '../Loaders.js';
import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import './AssignDelegate.scss';
import * as DelegateService from  './assignDelegateServices';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import kendo from '@progress/kendo-ui';
import '../commonStyle/tmsStyle.scss';
class AssignDelegate extends React.Component {

    defaultApprover = {FULLNAME : "Select Approver"};
    defaultDelegate = {FULLNAME : "Select Delegate"}
    constructor(props) {
super(props);
        this.state = {
            blocking:false,
            approverData : [],
            approverValue : {FULLNAME : "Select Approver"},
            delegateValue : {FULLNAME : "Select Delegate"},
            fromDateValue : new Date()
        }
    }

    

  async  getDelegateData () {
    console.log('getDelegateData');
      const delegateData = await DelegateService.getApproverDelegateData();
      if(delegateData != "ERROR")
      this.setState ({approverData : delegateData});
    }


handleApproverChange = (event) => {
    this.setState({
        approverValue: event.target.value
    });

    if(this.state.delegateValue.USERNAME === event.target.value.USERNAME)
    {
        toast.error("Approver and Delegate cannot be the same", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"            });
    }

    if(event.target.value.FULLNAME != "Select Approver" || this.state.delegateValue.FULLNAME != "Select Delegate" || this.state.toDateValue != undefined || this.state.fromDateValue != undefined)
    
    {

    }
   
   
}

handleDelegateChange = (event) => {
    this.setState({
        delegateValue: event.target.value
    });

    if(this.state.approverValue.USERNAME === event.target.value.USERNAME)
    {
        toast.error("Approver and Delegate cannot be the same", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"            });
    }
   
}

fromDateHandleChange = (event) => {

    //  this.state.fromDateValue = event.value;
    this.setState ({fromDateValue : event.value});
var now = new Date();
var d = new Date(event.value);
if (now.getTime() > d.getTime()) {

    toast.error("Please make sure that the date range begins 1 day after today’s date", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });
   
}

}

toDateHandleChange = (event) => {
     
var endDate = event.value;
 endDate = kendo.toString(new Date(endDate), "yyyyMMdd");

//   this.state.toDateValue = event.value;
this.setState ({toDateValue : event.value});

var startDate = this.state.fromDateValue;
 startDate = kendo.toString(new Date(startDate) , "yyyyMMdd");

 var now = new Date();
var d = new Date(event.value);
if (now.getTime() > d.getTime()) {

    toast.error("Please make sure that the date range begins 1 day after today’s date", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });
   
}

var dateDiff = endDate - startDate;

if(dateDiff == 0)
{
    toast.error("Please select end date greater than current date", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });
        
}



// if(dateDiff >= 1)
// {
//     toast.error("Please make sure that the date range begins 1 day after today’s date", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//  progress: undefined,
  //      theme:"colored"//         });
// }
}

async saveAssignDelegateData(inputObj) {

    const response = await DelegateService.postAssignDelegateData(inputObj);
    if(response != "ERROR")
    toast.success("Delegate Assigned Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"        });

        else
        {
            toast.error("Delegate not assigned", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
         progress: undefined,
        theme:"colored"                });
        }

       this.setState ({approverValue : {FULLNAME : "Select Approver"},
    delegateValue : {FULLNAME : "Select Delegate"},

    toDateValue : "",
    fromDateValue : new Date()});

       

}

assignDelegate() {

    var today = new Date();

    if(this.state.fromDateValue.getTime() == today.getTime())
    {
        toast.error("Please make sure Date Range Starts one day after today's Date", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"            });
    }

    else if(this.state.fromDateValue.getTime () >= this.state.toDateValue.getTime())

    {
        toast.error("Please make sure that to Date is greater than, from Date", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"            });
    }
    else{
  var inputObj = {};
    inputObj["im_approver"] = this.state.approverValue.USERNAME;
			inputObj["im_delegator"] = this.state.delegateValue.USERNAME;
			inputObj["im_startdate"] = kendo.toString(new Date(this.state.fromDateValue), "yyyyMMdd");
            inputObj["im_enddate"] = kendo.toString(new Date(this.state.toDateValue), "yyyyMMdd");
             this.saveAssignDelegateData(inputObj);
    }
         
}

    componentDidMount(){
        console.log('componentDidMount');
      this.getDelegateData();
    //   this.state.assignDisabled = true;
    //   this.setState ({assignDisabled : true});
    }
render()
{
    return(
<div>

{/* <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/> */}
{/* Same as */}
{/* <ToastContainer /> */}

{/* <BlockUi tag="div" blocking={this.state.blocking}
        
        loader={<Loader
            type="Circles"
            color="#00BFFF"
            height={100}
            width={100}
            timeout={3000} //3 secs
    
         />}>                */}
         <BlockUi tag="div" blocking={this.state.blocking}
            loader={<Loaders />}>
            <MDBContainer fluid>
                <MDBRow>
                    <MDBCol sm="12" className="titleBox"><label>Assign Delegate</label></MDBCol>
                </MDBRow>
                <div className="contentborder">
                <MDBRow>
                    <MDBCol md = "1"></MDBCol>
                    <MDBCol md="2">
                        <label>Approver <em>*</em> </label>
                    </MDBCol>
                    <MDBCol md="3">
                        <DropDownList data={this.state.approverData} textField = "FULLNAME" dataItemKey = "USERNAME" value = {this.state.approverValue}
                        defaultItem={this.defaultApprover} onChange = {this.handleApproverChange} ></DropDownList>
                    </MDBCol>
                </MDBRow>
                <br></br>
                <MDBRow>
                <MDBCol md = "1"></MDBCol>
                    <MDBCol md="2">
                        <label>Delegate <em>*</em> </label>
                    </MDBCol>
                    <MDBCol md="3">
                      <DropDownList data={this.state.approverData} textField = "FULLNAME" dataItemKey = "USERNAME" value = {this.state.delegateValue}
                      defaultItem = {this.defaultDelegate} onChange = {this.handleDelegateChange}></DropDownList>
                    </MDBCol>
                    </MDBRow>
                    <br></br>
                    <MDBRow>
                    <MDBCol md = "1"></MDBCol>
                        <MDBCol md="2">
                            <label>Validity Date <em>*</em></label>
                        </MDBCol>
                        <MDBCol md="3">
                          <DatePicker  value={this.state.fromDateValue}
                        onChange={this.fromDateHandleChange}></DatePicker>
                        </MDBCol>
                        <MDBCol md = "1"></MDBCol>
                        <MDBCol md="1">
                            <label>To Date <em>*</em></label>
                        </MDBCol>
                        <MDBCol md="3">
                         <DatePicker  value={this.state.toDateValue}
                         format="MM/dd/yyyy" 
                         formatPlaceholder="formatPattern"
                        onChange={this.toDateHandleChange}></DatePicker>
                        </MDBCol>
                    </MDBRow>
                    <br></br>
                    
                   <MDBRow>
                       <MDBCol md = "12" style={{textAlign:'center'}}>
                           <button type="submit"  className="btn k-button k-button-icontext" disabled = {this.state.approverValue.FULLNAME == "Select Approver" || this.state.delegateValue.FULLNAME == "Select Delegate" || this.state.approverValue.FULLNAME == this.state.delegateValue.FULLNAME || this.state.toDateValue == undefined } onClick = {this.assignDelegate.bind(this)}>Assign</button>
                           </MDBCol>
                   </MDBRow>
                   </div>
                </MDBContainer> 
            </BlockUi>
            </div>
    );
}
}

export default AssignDelegate;

